import { render, staticRenderFns } from "./StatsToolbar.vue?vue&type=template&id=56ecdbbf&"
import script from "./StatsToolbar.vue?vue&type=script&lang=js&"
export * from "./StatsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./StatsToolbar.vue?vue&type=style&index=0&id=56ecdbbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports